<template>
  <form
    role="search"
    class="bd-search d-flex align-items-center"
    @submit.stop.prevent
  >
    <b-input-group>
      <b-form-input
        id="bd-search-input"
        autocomplete="off"
        type="search"
        v-model="searchText"
        @click.stop="showSearchDropdown = true"
        @keypress.enter="search"
        placeholder="Search here"
        aria-label="Search docs"
      ></b-form-input>
      <b-input-group-append>
        <div class="search-icon-wrapper">
          <b-icon icon="search" font-scale="1.6" />
        </div>
      </b-input-group-append>
    </b-input-group>
    <!-- hidiing dropdown for now as it has been planned for v2 -->
    <div
      v-if="false"
      :class="{ 'search-dropdown': true, hidden: !showSearchDropdown }"
      ref="searchDropdown"
      id="search-dropdown"
    >
      <div class="heading-row">
        <div class="heading">Tasks</div>
        <div class="view-all">View All</div>
      </div>
      <b-card no-body class="" v-for="x in 3" :key="x">
        <div class="first-row">
          <div class="date-wrapper">
            <img src="@/assets/icons/timer_clock_outlined.svg" />
            <p>Aug 10</p>
          </div>
          <div class="actions-wrapper">
            <div class="timer-wrapper">
              <p v-show="timerActive" class="time">00:00:00</p>
              <p v-show="!timerActive" class="time-paused">
                00:00:00
              </p>
              <img
                v-show="timerActive"
                src="@/assets/icons/timer_pause_outlined.svg"
              />
              <img
                v-show="!timerActive"
                src="@/assets/icons/timer_play_outlined.svg"
              />
            </div>
          </div>
        </div>
        <div class="title-row">
          Process Business cards
        </div>
        <div class="data-row">
          <b-avatar class="" text="JP" size="2.8rem" src="1"></b-avatar>
          <div class="icons-group d-flex">
            <div class="icon-group-1 d-flex" v-if="item.attachments > 0">
              <img
                src="@/assets/icons/attachment_light.svg"
                alt=""
                class="mr-2"
              />
              <div class="font-sm secondary--text font-family-regular ">
                {{ item.attachments }}
              </div>
            </div>

            <div class="icon-group-2 d-flex" v-if="item.checklists > 0">
              <img
                src="@/assets/icons/checklist_light.svg"
                alt=""
                class="mr-2"
              />
              <div class="font-sm secondary--text font-family-regular">
                {{ item.checklists }}
              </div>
            </div>

            <div class="icon-group-3 d-flex" v-if="item.comments > 0">
              <img src="@/assets/icons/comment_light.svg" alt="" class="mr-2" />
              <div class="font-sm secondary--text font-family-regular">
                {{ item.comments }}
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      showSearchDropdown: false,
      timerActive: true,
      searchText: '',
      item: {
        attachments: 4,
        checklists: 6,
        comments: 10
      }
    };
  },
  mounted() {
    // window.addEventListener("click", this.onClick);
    
    if (this.$route.query.q) {
      this.searchText = this.$route.query.q
    }
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'clearSearchBox') {
        this.searchText = ''
      }
    })
  },
  beforeDestroy() {
    // window.removeEventListener("click", this.onClick);
    this.unsubscribe()
  },
  methods: {
    search() {
      if (this.searchText.trim() === "") {
        return
      }
      this.$router.push({
        name: 'Search',
        query: {
          q: this.searchText
        }
      })
    },
    onClick(e) {
      if (document.getElementById("search-dropdown").contains(e.target)) {
        // Clicked in box
        console.log("cib");
      } else {
        // Clicked outside the box
        this.showSearchDropdown = false;
        console.log("cob");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";
$sky-blue: #64a4fb;
p {
  line-height: normal;
}
form.bd-search {
  margin-right: 1.3rem;
}
#bd-search-input {
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
  border-right: none;
  width: 150px;
}
#bd-search-input:focus {
  border-color: #d4d4d4;
  outline: none;
  box-shadow: none;
}
.hidden {
  display: none;
}
.input-group-append {
  border: 1px solid #d4d4d4;
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
  border-left: none;
  background-color: $white;
  .search-icon-wrapper {
    display: flex;
    padding-right: 7px;
    justify-content: center;
    align-items: center;
    z-index: 101;
    color: $primary;
  }
}
.search-dropdown {
  border-radius: 10px;
  position: absolute;
  width: 400px;
  background: white;
  border: 1px solid #d4d4d4;
  z-index: 99;
  color: $primary-dark;
  top: 100%;
  font-size: 14px;
  padding: 0 10px;
  // left: 0;
  // right: 0;
  .view-all {
    color: $sky-blue;
    font-weight: bold;
    cursor: pointer;
  }
  .heading-row {
    display: flex;
    margin: 15px 0;
    > .heading {
      font-weight: bold;
    }
    > .view-all {
      margin-left: auto;
    }
  }
  .card {
    border: 1px solid #dcebf4;
    margin: 10px 0;
    padding: 10px;
    > div {
      padding-bottom: 10px;
    }
    > div:last-child {
      padding-bottom: 0px;
    }
    .title-row {
      font-weight: bold;
    }
    .data-row {
      display: flex;
      .icons-group {
        > div {
          margin-left: 10px;
          > div {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
